import { getExpressionData } from "api/expression";
import { getTagData } from "api/tags";
import areaApiConfig from "./areaApiConfig";

const largeConfig = {
  getTagData,
  getExpressionData,
  areaApiConfig
};

export default largeConfig;